import { Tag } from 'antd';
import { Model, Training, Run, InboxFileRow } from '../../types';
import { Label, LabelDefinition } from '../../types/label';
import React from 'react';

import {
  trainingOptions,
  modelTrainingOptions,
  datasetFileStatusOptions,
  inboxFileStatusOptions,
  inferenceOptions,
  tagOptions,
  labelOptions,
  datasetFilterOptions,
} from '../status-templates';
import { DatasetFileVersion } from '../../types/dataset';

export const isFinished = (inference: { status: string; run?: Run }) => {
  return inference && ((inference.run && inference.run.status === 'SUCCESS') || inference.status === 'FINISHED');
};

export const getStatus = (inference: { status: string; run?: Run }) => {
  return inference && ((inference.run && inference.run.status) || inference.status);
};

export const getModelTrainingStatus = (model: Model) => {
  return !!model.lastModelVersionId ? modelTrainingOptions.trained : modelTrainingOptions.untrained;
};

export const getTrainingStatus = (training: Training) => {
  return trainingOptions[training.status] || trainingOptions['UNKNOWN'];
};

export const getInferenceStatus = (inference: { status: string }) => {
  return inferenceOptions[inference.status] || inferenceOptions['UNKNOWN'];
};

export const getDatasetFileStatus = (datasetfile: DatasetFileVersion) => {
  const fileIsProcessing = ['PROCESSING', 'PREP_FINISHED'].includes(datasetfile.datasetFile.status);
  if (fileIsProcessing) {
    return datasetFileStatusOptions[datasetfile.datasetFile.status];
  } else {
    return datasetFileStatusOptions[datasetfile.properties.annotationState];
  }
};

export const getDatasetFilterOption = (stateFilter: string) => {
  return datasetFilterOptions[stateFilter || 'ALL'];
};

export const getInboxFileStatus = (inboxFile: InboxFileRow) => {
  return inboxFileStatusOptions[inboxFile.inbox_status];
};

export const isReliableAndExitsOrManuallyApproved = (label: Partial<Label>) => {
  return (label.exists && label.reliable) || label.source === 'manual' || label.manuallyApproved;
};

export const isReliableAndNotOnDocument = (label: Partial<Label>) => {
  return !label.exists && label.reliable;
};

export const getTagStatus = (status: string) => {
  return (
    <Tag color={tagOptions[status].color} style={{ fontSize: 14, marginRight: '0px' }}>
      {tagOptions[status].label}
    </Tag>
  );
};

export const getLabelStatus = (label: Label & Partial<LabelDefinition>) => {
  if (label.reliable && !label.exists) {
    return labelOptions.notfound;
  } else if (
    !label.reliable ||
    (label.type && !label.valid) ||
    (label.rules && label.rules.findIndex(it => it.result !== 'valid') > -1)
  ) {
    return labelOptions.incorrect;
  } else {
    return labelOptions.correct;
  }
};

export const getFilterStatusLabel = (status: string) => {
  switch (status) {
    case 'SUCCESS':
      return 'Successful invoices';
    case 'ERROR':
      return 'Invoices with issues';
    case 'PROGRESS':
      return 'In progress';
    default:
      return '';
  }
};
